import React from "react";

import { withSnackbar } from "notistack";
import { API_CONFIG } from "common/config";

import "./styles/index.css";

const SharePage = (props: any) => {
  const urlParams = new URLSearchParams(window.location.search);
  const q = urlParams.get("q");
  console.log("q:", q);

  //file decode from base64
  let fileDecode;
  if (typeof Buffer === "function") {
    fileDecode = Buffer.from(q, "base64").toString("utf-8");
  } else {
    fileDecode = atob(q);
  }
  console.log("fileDecode", fileDecode);
  return (
    <>
      <div className="sharePageImage">
        {fileDecode && <img src={API_CONFIG.STATIC_URL + fileDecode}></img>}
      </div>
    </>
  );
};

export default withSnackbar(SharePage);
